(() => {
  function init() {
    const story = document.querySelector("[data-tsp-story]");
    const purchase = document.querySelector(".tsp-purchase");
    const bar = document.querySelector("[data-tsp-sticky]");
    if (!story || !purchase || story.dataset.ready) return;
    story.dataset.ready = "true";
    const buy = purchase.querySelector(".product-detail__buy-buttons");
    document
      .querySelectorAll("[data-tsp-jump], [data-tsp-purchase]")
      .forEach((link) => {
        link.addEventListener("click", (event) => {
          const target = link.hasAttribute("data-tsp-purchase")
            ? purchase.querySelector(".towa-engraving") || buy
            : document.querySelector(link.getAttribute("href"));
          if (!target) return;
          event.preventDefault();
          event.stopPropagation();
          target.scrollIntoView({
            behavior: "instant",
            block: link.hasAttribute("data-tsp-purchase") ? "center" : "start",
          });
          const focus = link.hasAttribute("data-tsp-purchase")
            ? target.querySelector("button")
            : target;
          if (focus) {
            if (!focus.hasAttribute("tabindex") && focus.tagName !== "BUTTON")
              focus.setAttribute("tabindex", "-1");
            focus.focus({ preventScroll: true });
          }
        });
      });
    if (bar && buy && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        },
        { threshold: 0 },
      );
      observer.observe(buy);
    }
    document.addEventListener("visibilitychange", () => {
      if (document.hidden)
        story.querySelectorAll("video").forEach((video) => video.pause());
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
